import { useCallback, useEffect, useMemo, useState } from "react";

export const useInfiniteDataTableItems = <T,>(
  items: T[] | undefined,
  page: number
) => {
  const [itemsByPage, setItemsByPage] = useState<Record<number, T[]>>({});

  useEffect(() => {
    if (!items) {
      return;
    }

    setItemsByPage((prev) => ({
      ...prev,
      [page]: items,
    }));
  }, [items, page]);

  const accumulatedItems = useMemo(
    () => {
      const currentItemsByPage = items
        ? {
            ...itemsByPage,
            [page]: items,
          }
        : itemsByPage;

      return Object.keys(currentItemsByPage)
        .map(Number)
        .sort((a, b) => a - b)
        .flatMap((pageNumber) => currentItemsByPage[pageNumber]);
    },
    [items, itemsByPage, page]
  );

  const resetAccumulatedItems = useCallback(() => {
    setItemsByPage({});
  }, []);

  return { accumulatedItems, resetAccumulatedItems };
};
